<div class="modal-header border-0 pb-0">
  <h5 class="modal-title">{{ t()["importSource.title"] }}</h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    [disabled]="isUploading()"
    (click)="activeModal.dismiss()"
  ></button>
</div>

<div class="modal-body pt-2">
  @if (infoMessage()) {
    <div class="alert alert-success py-2 mb-3">{{ infoMessage() }}</div>
  }

  @if (errorMessage()) {
    <div class="alert alert-danger py-2 mb-3">{{ errorMessage() }}</div>
  }

  <div
    class="{{
      isUploading()
        ? 'import-dropzone is-disabled'
        : isDragOver()
          ? 'import-dropzone is-drag-over'
          : 'import-dropzone'
    }}"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    <div class="d-flex align-items-center justify-content-center mb-2">
      <svg class="sa-icon sa-bold">
        <use href="/assets/icons/sprite.svg#upload-cloud"></use>
      </svg>
    </div>
    <h6 class="mb-1">{{ t()["importSource.dropzoneTitle"] }}</h6>
    <p class="text-muted mb-3">
      {{ t()["importSource.dropzoneDescription"] }}
    </p>
    <input
      #fileInput
      type="file"
      data-testid="source-file-input"
      class="d-none"
      multiple
      accept=".txt,.doc,.docx,.pdf"
      [disabled]="isUploading()"
      (change)="onFileSelectionChange($event)"
    />
    <button
      type="button"
      class="btn btn-outline-primary"
      [disabled]="isUploading()"
      (click)="fileInput.click()"
    >
      {{ t()["importSource.selectButton"] }}
    </button>
  </div>

  @if (fileItems().length) {
    <div class="workspace-asset-list list-group mt-3">
      @for (item of fileItems(); track item.id) {
        <div class="list-group-item workspace-asset-item">
          <div class="d-flex align-items-start justify-content-between gap-2">
            <div class="min-w-0">
              <div class="fw-600 text-truncate">{{ item.file.name }}</div>
              <small class="text-muted">{{
                formatFileSize(item.file.size)
              }}</small>
              @if (item.errorMessage) {
                <div class="text-danger small mt-1">
                  {{ item.errorMessage }}
                </div>
              }
            </div>

            <div class="d-flex align-items-center gap-2">
              <span class="{{ getStatusBadgeClass(item.status) }}">{{
                getStatusLabel(item.status)
              }}</span>
              <button
                type="button"
                class="btn btn-sm btn-icon btn-light"
                aria-label="Remove file"
                [disabled]="isUploading() || item.status === 'uploading'"
                (click)="removeItem(item.id)"
              >
                <svg class="sa-icon sa-bold">
                  <use href="/assets/icons/sprite.svg#x"></use>
                </svg>
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="small text-muted mt-3">{{ t()["importSource.noSources"] }}</div>
  }

  @if (summary()) {
    <div
      class="alert {{
        summary()?.failedCount ? 'alert-warning' : 'alert-success'
      }} py-2 mt-3 mb-0"
    >
      {{
        t()
          ["importSource.summaryText"].replace(
            "{importedCount}",
            (summary()?.importedCount ?? 0).toString()
          )
          .replace("{total}", (summary()?.total ?? 0).toString())
      }}
      @if (summary()?.failedCount) {
        <span>{{
          t()["importSource.failedCount"].replace(
            "{failedCount}",
            (summary()?.failedCount ?? 0).toString()
          )
        }}</span>
      }
    </div>
  }
</div>

<div class="modal-footer border-0 pt-2">
  <button
    type="button"
    class="btn btn-light"
    [disabled]="isUploading()"
    (click)="activeModal.dismiss()"
  >
    {{ t()["importSource.cancel"] }}
  </button>
  <button
    type="button"
    class="btn btn-primary"
    data-testid="source-import-submit"
    [disabled]="!canImport()"
    (click)="workspaceAssets()"
  >
    {{
      isUploading() ? t()["importSource.importing"] : t()["importSource.import"]
    }}
  </button>
</div>
